import { Injectable, signal } from '@angular/core';

import { StorageService, UserInfoService, ApiService } from 'src/services';
import { Res } from 'src/models';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
private readonly TOKEN_KEY = 'token';

  private _isLoggedIn = signal<boolean>(false);
  isLoggedIn = this._isLoggedIn.asReadonly();

  constructor(
    private storage: StorageService,
    private userInfoService: UserInfoService,
    private apiService: ApiService
  ) {}

  /** 登录成功后统一调用 */
  async loginSuccess(loginResult: string | { token?: string } | null | undefined) {
    const token = this.extractToken(loginResult);
    if (!token) {
      throw new Error('登录返回缺少 token');
    }
    this.storage.setItem(this.TOKEN_KEY, token);
    const loaded = await this.userInfoService.fetchAndSetUserInfo();
    if (!loaded) {
      this.logout();
      throw new Error('获取用户信息失败');
    }
    this._isLoggedIn.set(true);
  }

  /** 应用启动时恢复 */
  async restoreLogin() {
    const token = this.storage.getItem(this.TOKEN_KEY);
    if (!token) return;

    try {
      const loaded = await this.userInfoService.fetchAndSetUserInfo();
      this._isLoggedIn.set(loaded);
      if (!loaded) {
        this.logout();
      }
    } catch {
      this.logout();
    }
  }

  logout() {
    this.storage.removeItem(this.TOKEN_KEY);
    this.storage.removeItem('wasmToken');
    this.storage.removeItem('userAssets');
    this.userInfoService.clearUserInfo();
    this._isLoggedIn.set(false);
  }

  get token(): string | null {
    return this.storage.getItem(this.TOKEN_KEY);
  }

  extractToken(loginResult: string | { token?: string } | null | undefined): string | null {
    if (!loginResult) return null;
    if (typeof loginResult === 'string') return loginResult;
    return loginResult.token ?? null;
  }

  async refreshWasmToken(): Promise<string | null> {
    if (!this.token) {
      this.storage.removeItem('wasmToken');
      return null;
    }

    try {
      const res: Res = await this.apiService["exchangeWasmToken"]({});
      if (res.status !== 'success') {
        this.storage.removeItem('wasmToken');
        return null;
      }

      const wasmToken = this.extractToken(res.result);
      if (!wasmToken) {
        this.storage.removeItem('wasmToken');
        return null;
      }

      this.storage.setItem('wasmToken', wasmToken);
      return wasmToken;
    } catch {
      this.storage.removeItem('wasmToken');
      return null;
    }
  }
}
